const NAVY = "#001F3F";
const SUPERADMIN_NAVY = "#081A4B";

const themeMap = {
    "brand-green": "#14532d",
    navy: "#001F3F",
    amber: "#ba6a36",
    espresso: "#261311",
    champagne: "#e6c8b7",
    cognac: "#c3955b",
    emerald: "#1c3934",
};

export const getTenantLoginAccent = () => {
    try {
        const themeId = localStorage.getItem("theme") || "navy";
        return themeMap[themeId] || NAVY;
    } catch (_err) {
        return NAVY;
    }
};

export const getSuperadminLoginAccent = () => SUPERADMIN_NAVY;
